<template>
  <BaseSection v-if="getCurrentStep>=step">
    <template #title>{{step}}. Update Line Features</template>

    <template #content>

      <template v-if="getAddonsView('line-features').length">
        <template v-for="(addon,index) in getAddonsView('line-features')">
          <div :key="index" :class="`d-flex justify-space-between ${addon.state.color}`" v-if="addon.id">
            <div>{{addon.name}}</div>
            <div class="d-flex justify-end">
              <div>{{addon.price | formatCurrency}}</div> <div class="font-weight-bold addon_state text-right">{{addon.state.text}}</div>
            </div>
          </div>
        </template>
      </template>

      <template v-else>
        <div>There are no line features selected.</div>
      </template>

    </template>
  </BaseSection>
</template>

<script>
  import { mapGetters } from 'vuex';
  import BaseSection from '@/components/Products/ProductTypes/AllProducts/ChangeTariff/ChangedSections/BaseSection';

  export default {

    props: {
      step: {
        type: Number,
        default: 0
      },
    },

    components: {BaseSection},

    computed: {
      ...mapGetters('changeTariff',['getCurrentStep','getSection','getPreviousAddons','getCurrentAddons','getAddonsView']),
    },

  }
</script>

<style lang="scss" scoped>

  .addon_state {
    width: 80px;
  }

</style>
